<div class="circle-avatar d-flex justify-content-center align-items-center" [ngStyle]="{'background-image':'url(' + img + ')', 'background-color':backgroundColor, 'width': width, 'height':height, 'border-radius':radius}">
    <ng-container *ngIf="data">
        <span [class]="dataClass">{{data}}</span>
    </ng-container>
    <!-- <img [src]="img" alt="" *ngIf="img" class="object-fit-cover"> -->
</div>